export {default} from './Header';



// WEBPACK FOOTER //
// ./src/components/GlobalLayout/Header/index.ts